// @ts-check
// WP4 / G-2 (Michael, 2026-09-17): exact ruled wording for the per-licence
// local-waveform-deletion grant (API field name stays `evictionGrant` - only the
// user-visible copy uses "local waveform deletion" instead of "evict"/"eviction").
//
// Every user-visible string for this control lives HERE, and only here, so a future
// wording change from Michael is a one-line edit in this file.
export const EVICTION_GRANT_COPY = {
  columnHeader: 'Local waveform deletion',
  onLabel: 'On',
  offLabel: 'Off',
  enableMenuLabel: 'Allow local waveform deletion',
  disableMenuLabel: 'Stop local waveform deletion',
  enableConfirmLabel: 'Allow',
  disableConfirmLabel: 'Stop',
  enableTitle: (serialNumber) => `Allow local waveform deletion for ${serialNumber}?`,
  enableBody:
    'This device may delete its local copy of ECG waveforms that are already saved in the cloud archive, to free storage. After that, the archive holds the only copy and the device retrieves a waveform when the recording is opened. Off by default.',
  disableTitle: (serialNumber) => `Stop local waveform deletion for ${serialNumber}?`,
  disableBody:
    'The device stops deleting local waveform copies at its next licence check. Copies it has already deleted are not restored; they remain retrievable from the archive.',
  enabledToast: (serialNumber) => `Allowed local waveform deletion for ${serialNumber}`,
  disabledToast: (serialNumber) => `Stopped local waveform deletion for ${serialNumber}`,
  actionTitle:
    "Controls whether this licence's device may delete local waveform copies already saved in the cloud archive",
};
